import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from "react-share";
import html2canvas from "html2canvas";
import { generateShareableUrl } from "../utils/urlParams";

const ShareTimeline = ({
  timelineRef,
  timeline,
  temperature,
  customDurations,
}) => {
  const generateImage = async () => {
    if (timelineRef.current) {
      try {
        const canvas = await html2canvas(timelineRef.current);
        const image = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = image;
        link.download = "sourdough-schedule.png";
        link.click();
      } catch (error) {
        console.error("Error generating image:", error);
      }
    }
  };

  const shareUrl = generateShareableUrl(
    timeline[0].startTime,
    temperature,
    customDurations,
    timeline[0].startTime > timeline[timeline.length - 1].startTime
      ? "reverse"
      : "forward"
  );

  const title = "Check out my Sourdough Baking Schedule!";

  return (
    <div className="share-timeline-container my-3">
      <ButtonGroup>
        <FacebookShareButton url={shareUrl} quote={title}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} title={title}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>

        <Button
          variant="outline-primary"
          onClick={generateImage}
          className="ms-2"
        >
          Download Schedule Image
        </Button>

        <Button
          variant="outline-secondary"
          onClick={() => {
            navigator.clipboard.writeText(shareUrl);
          }}
          className="ms-2"
        >
          Copy Link
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default ShareTimeline;
